'use strict';
var input = document.querySelector('.form__input');
var inputButton = document.querySelector('.form__input-button');
input.addEventListener('input', function(e) {
    var stringValue = e.target.value;
    var check = /@.*\./.test(stringValue);
    if (stringValue === '') {
        e.target.classList.remove('form__input--filled');
        inputButton.disabled = true;
    } else if (!check) {
        e.target.classList.remove('form__input--filled');
        inputButton.disabled = true;
    } else if (check) {
        e.target.classList.add('form__input--filled');
        inputButton.disabled = false;
    }
});
var exhibitions = document.querySelector('.section__article-wrapper');
var events = document.querySelectorAll('.events');
var news = document.querySelectorAll('.news');
var sectionObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
        if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
        }
    });
}, {
    root: null,
    threshold: 0.1,
    delay: 100
});
sectionObserver.observe(exhibitions);
events.forEach(function(article) {
    return sectionObserver.observe(article);
});
news.forEach(function(article) {
    return sectionObserver.observe(article);
});

//# sourceMappingURL=Museum_2.4fe2df7a.js.map
